import { IItemTagsClient } from './IItemTagsClient';
import { ItemTagsClientApi } from './itemTagsClientApi';

export * from './IItemTagsClient';
export * from './itemTagTypes';

// Item Tags has a real backend (routes-itemtags.json) — always use the real client.
export const itemTagsClient: IItemTagsClient = new ItemTagsClientApi();
